<template>
  <div class="bottom-nav__wrapper">
    <nav
      v-if="fastPointsList"
      class="bottom-nav"
    >
      <component
        v-for="(point, i) in fastPointsList"
        :key="`bottom-nav-${i}`"
        :is="point.isDisabled ? 'span' : 'router-link'"
        :class="{ 'menu-point': point.isDisabled }"
        :to="point.isDisabled ? null : routeOf(point)"
        :aria-label="point.anchor"
      >
        <i :class="point.iconName" />
        <span
          v-if="!point.isDisabled && bubbleOf(point)"
          class="bubble"
        >
          {{ bubbleOf(point) }}
        </span>
      </component>
    </nav>
    <nav
      v-else
      class="bottom-nav"
    >
      <component
        :is="isOff('program') ? 'span' : 'router-link'"
        :class="{ 'menu-point': isOff('program') }"
        :to="isOff('program') ? null : { name: 'program' }"
      >
        <i class="exu-daily-book" />
      </component>
      <component
        :is="isOff('participants') ? 'span' : 'router-link'"
        :class="{ 'menu-point': isOff('participants') }"
        :to="isOff('participants') ? null : '/participants/1'"
      >
        <i class="exu-users" />
      </component>
      <component
        :is="isOff('chatView') ? 'span' : 'router-link'"
        :class="{ 'menu-point': isOff('chatView') }"
        :to="isOff('chatView') ? null : '/chat'"
      >
        <span
          v-if="newChatUnread && !isOff('chatView')"
          class="bubble"
        >
          {{ newChatUnread }}
        </span>
        <i class="exu-mail-2" />
      </component>
      <component
        :is="isOff('notifications') ? 'span' : 'router-link'"
        :class="{ 'menu-point': isOff('notifications') }"
        :to="isOff('notifications') ? null : '/notifications/1'"
      >
        <i class="exu-annotation-alert" />
        <span
          v-if="newNotification && !isOff('notifications')"
          class="bubble"
        >
          {{ newNotification }}
        </span>
      </component>
    </nav>
  </div>
</template>

<script>
import { pointRoute } from '@/components/mixins/menuPoints';

export default {
  name: 'BottomNav',
  props: {
    // Состав панели из fast_apps конфига, уже разобранный и обрезанный до
    // четырёх кнопок (menuPoints.js). null — сервер составом не управляет,
    // тогда кнопки те, что зашиты в разметке ниже.
    fastPointsList: {
      type: Array,
      default: null,
    },
    // Список модулей из config.json — тот же, по которому дашборд строит
    // плитки. Зашитой разметке он нужен не для состава, а только для
    // состояния.
    pointsList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    newNotification() {
      return this.$store.getters.getNewNotificationCount < 10 ? this.$store.getters.getNewNotificationCount : '9+';
    },
    newChatUnread() {
      return this.$store.getters.getUnreadChatCount < 100 ? this.$store.getters.getUnreadChatCount : '9+';
    },
    unApprovedMeeting() {
      return this.$store.getters.getUnApproveMeetingCount < 10 ? this.$store.getters.getUnApproveMeetingCount : '9+';
    },
    disabledModules() {
      return this.pointsList
        .filter((item) => item.isDisabled === true)
        .map((item) => item.moduleName);
    },
  },
  methods: {
    // Та же функция, которой menuPoints.js проверяет, что ссылка собирается
    routeOf: pointRoute,
    bubbleOf(point) {
      if (point.moduleName === 'chatView') return this.newChatUnread;
      if (point.moduleName === 'notifications') return this.newNotification;
      if (point.moduleName === 'userCalendar') return this.unApprovedMeeting;
      return null;
    },
    // Зашитая разметка — для сервера, который составом панели не управляет.
    // Погашенность ей берётся из конфига, иначе панель ведёт туда, где
    // дашборд уже показывает серую плитку.
    // Гасим строго по явному isDisabled: отсутствие модуля в конфиге ничего
    // не значит — панель водит и туда, чего в плитках нет (участники живут в
    // /participants, а конфиг мероприятия перечисляет exhibitors).
    isOff(moduleName) {
      return this.disabledModules.includes(moduleName);
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/style/variables.scss';

.bottom-nav {
  display: flex;
  width: 100%;
  max-width: 760px;
  // height: 60px;
  padding: 10px 10px;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  background: $color-base;
  border-radius: 30px;
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, .12);

  @media (min-width: 480px) {
    & {
      width: auto;
      gap: 40px;
    }
  }

  & > a, .menu-point {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: 2px solid $color-primary;
    border-radius: 50%;
    text-decoration: none;
    color: $color-primary;
    & > [class^="exu-"], & > [class*=" exu-"] {
      font-size: 20px;
    }

    &.router-link-exact-active, &.router-link-active {
      background: $color-accent;
      border-color: $color-accent;
      & > [class^="exu-"], & > [class*=" exu-"] {
        color: $color-base;
      }
    }

    .bubble {
      position: absolute;
      bottom: -2px;
      right: -2px;
      display: flex;
      width: 20px;
      height: 20px;
      padding: 3px;
      font-size: .8rem;
      line-height: .8rem;
      background: $color-badge;
      // Обводка фоном панели: под счётчиком бывает оранжевая заливка
      // активного пункта, а красный от оранжевого сам по себе не отличим.
      border: 2px solid $color-base;
      border-radius: 50%;
      color: $color-base;
      align-items: center;
      justify-content: center;
    }
  }
  .menu-point {
    color: $color-disabled;
    border-color: $color-disabled;
  }
}
</style>
